import {
  ArrowLeftIcon,
  ArrowRightIcon,
  UploadIcon,
} from "@radix-ui/react-icons";
import { Dispatch, MutableRefObject, SetStateAction } from "react";
import { Document, Page } from "react-pdf";
import { PulseLoader } from "react-spinners";
import {
  CenteredFlexContainer,
  ChooseContainer,
  ContainerGroup,
  ErrorText,
  NextButton,
  PrivacyNote,
  TextButton,
  Upload,
} from "./SharedComponents";

type WelcomeLayoutProps = {
  resetParser: () => void;
  setNumPages: Dispatch<SetStateAction<number | null>>;
  numPages: number | null;
  setPDF: Dispatch<SetStateAction<any>>;
  PDF: any;
  addText: (items: any, index: number) => void;
  transcriptDetected: MutableRefObject<boolean | null>;
  // The transcript has been read but the degree lists it is matched against are still loading.
  waitingForPrograms: boolean;
  startingYear: { label: any; value: number } | null;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  canExit?: boolean;
  onExit?: () => void;
};

export default function WelcomeLayout({
  resetParser,
  setNumPages,
  numPages,
  setPDF,
  PDF,
  addText,
  transcriptDetected,
  waitingForPrograms,
  startingYear,
  setCurrentPage,
  canExit = false,
  onExit,
}: WelcomeLayoutProps) {
  return (
    <CenteredFlexContainer>
      <ChooseContainer $maxWidth="90%" $minWidth="90%">
        {canExit && onExit && (
          <TextButton
            onClick={onExit}
            style={{
              position: "absolute",
              left: "2.5%",
              top: "3%",
            }}
          >
            <ArrowLeftIcon />
            <p>Back</p>
          </TextButton>
        )}
        <div style={{ display: "none" }}>
          <Document
            file={PDF}
            onLoadSuccess={(pdf) => {
              resetParser();
              setNumPages(pdf.numPages);
            }}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                onGetTextSuccess={({ items, styles }) => {
                  addText(items, index);
                }}
                renderTextLayer={true}
              />
            ))}
          </Document>
        </div>

        <h1>Welcome to Penn Degree Plan!</h1>
        <ContainerGroup>
          <label>
            <input
              type="file"
              accept=".pdf"
              hidden
              onChange={(event) => {
                if (event.target.files) setPDF(event.target.files[0]);
              }}
            />
            <Upload>
              <p style={{ fontSize: "1.2rem" }}>Upload Transcript</p>
              {PDF?.name ? (
                <p>{PDF?.name}</p>
              ) : (
                <UploadIcon width={20} height={20} />
              )}
            </Upload>
          </label>
          <PrivacyNote>
            Your transcript is never uploaded or saved. It is read entirely on
            your computer, and only the courses found in it are added to your
            plan.
          </PrivacyNote>
          <ErrorText>
            {PDF &&
              transcriptDetected.current !== null &&
              (transcriptDetected.current === true
                ? ""
                : "Can't detect a transcript! Try another file.")}
          </ErrorText>
          <NextButton
            onClick={() => {
              if (startingYear && startingYear?.value !== 0) setCurrentPage(1);
            }}
            disabled={PDF && transcriptDetected.current === true ? false : true}
          >
            {!waitingForPrograms && <div>Next</div>}
            <PulseLoader size={8} color={"white"} loading={waitingForPrograms} />
          </NextButton>
        </ContainerGroup>
        <TextButton
          onClick={() => {
            resetParser();
            setCurrentPage(2);
          }}
          style={{ borderBottom: "1px solid #aaa" }}
        >
          <p>Enter information manually</p>
          <ArrowRightIcon />
        </TextButton>
      </ChooseContainer>
    </CenteredFlexContainer>
  );
}
